import { Auth } from 'aws-amplify';
import aws4 from 'aws4';

import { getCookie } from 'utils/cookies';

export const configFile = '/config.json';

export const WEBSOCKET_URL = async () => {
  const configData = await fetch(configFile)
    .then(res => res.json())
    .then(data => data);
  return `${configData.AWS_SOCKET_HOST}.${configData.AWS_SERVICE}.${configData.AWS_REGION}.amazonaws.com`;
};

export const getSignedForWebsocket = async () => {
  const credentials = await Auth.currentCredentials();
  const configData = await fetch(configFile)
    .then(res => res.json())
    .then(data => data);

  const { accessKeyId, secretAccessKey, sessionToken } = credentials;

  const host = await WEBSOCKET_URL();
  return aws4.sign(
    {
      host,
      path: `/${
        configData.AWS_VERSION
      }?X-Amz-Security-Token=${encodeURIComponent(sessionToken)}`,
      service: configData.AWS_SERVICE,
      region: configData.AWS_REGION,
      signQuery: true
    },
    {
      accessKeyId,
      secretAccessKey
    }
  );
};

export default async config => {
  const loginStore = getCookie('loginStore');
  let configData;
  if (!config) {
    configData = await fetch(configFile)
      .then(res => res.json())
      .then(data => data);
  } else {
    configData = config;
  }

  return {
    Auth: {
      region: configData.AWS_REGION,
      identityPoolId: configData.AWS_IDENTITY_POOL_ID,
      identityPoolRegion: configData.AWS_REGION,
      userPoolId: configData.AWS_USER_POOL_ID,
      userPoolWebClientId: configData.AWS_USER_POOL_WEBCLIENT_ID,
      storage:
        loginStore && loginStore === 'localStorage'
          ? localStorage
          : sessionStorage
    },
    API: {
      endpoints: [
        {
          name: 'ApiGatewayChnet',
          endpoint: configData.AWS_ENV_API_GATEWAY,
          region: configData.AWS_REGION
        }
      ]
    }
  };
};
